// extracted by mini-css-extract-plugin
module.exports = {"boxtext":"TextBox_boxtext__3zMCV","boxText_p":"TextBox_boxText_p__lS-_c"};